"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowInvokeAction = void 0;
var WorkflowInvokeAction;
(function (WorkflowInvokeAction) {
    WorkflowInvokeAction["None"] = "";
    WorkflowInvokeAction["CreateSubTasks"] = "createSubTasks";
    WorkflowInvokeAction["RemoveSubTasks"] = "removeSubTasks";
})(WorkflowInvokeAction = exports.WorkflowInvokeAction || (exports.WorkflowInvokeAction = {}));
//# sourceMappingURL=workflow-invoke-action.js.map